module.exports = function(bootstrap) {
	bootstrap.directive('dateInput', ["$filter", "$window", "services", "brand", "navigation", "session", "$q",
		function($filter, $window, services, brand, navigation, session, $q) {
		return {
			replace: true,
			template: '<input type="date">',
			scope: {},
			controller: ["$scope", function($scope) {
			}]
		}
	}])
};